export { default } from './ZoomEmbed';
